import type { LineItem } from '@/types'

// Fallback French VAT rates, used only until the configured tax rates load or if
// none are active (AC-2.5.2-023 / 2.6.3-018). The live dropdown sources
// Settings > Tax rates (2.11.8 BR05).
export const TAX_RATES = [0, 5.5, 10, 20] as const

// Compute the line total: qty x unit price + tax (AC-2.5.2-024 / 2.6.3-018).
export function computeLineTotal(
  item: Pick<LineItem, 'quantity' | 'unit_price' | 'tax_rate'>
): number {
  const base = (item.quantity || 0) * (item.unit_price || 0)
  return Math.round((base + (base * (item.tax_rate || 0)) / 100) * 100) / 100
}

export function computeUnitPriceFromLineTotal(
  item: Pick<LineItem, 'quantity' | 'tax_rate'>,
  lineTotal: number
): number {
  const quantity = item.quantity || 0
  if (quantity <= 0) return 0

  const taxMultiplier = 1 + (item.tax_rate || 0) / 100
  if (taxMultiplier <= 0) return 0

  return Math.round((lineTotal / quantity / taxMultiplier) * 100) / 100
}

export function computeTotals(items: LineItem[]) {
  let subtotal = 0
  let taxTotal = 0
  for (const it of items) {
    const base = (it.quantity || 0) * (it.unit_price || 0)
    subtotal += base
    taxTotal += (base * (it.tax_rate || 0)) / 100
  }
  const round = (n: number) => Math.round(n * 100) / 100
  return {
    subtotal: round(subtotal),
    tax_total: round(taxTotal),
    total: round(subtotal + taxTotal),
  }
}

export function missingUnitPriceIndexes(items: LineItem[]): number[] {
  return items.flatMap((item, index) =>
    item.unit_price === undefined ? [index] : []
  )
}

export function emptyLineItem(): LineItem {
  return {
    description: '',
    quantity: 1,
    unit_price: undefined,
    tax_rate: 20,
    line_total: 0,
  }
}
